import React from "react";

const Subscription: React.FC = () => {
  return (
    <div className="pricing-wrapper">
      <div className="pricing-header">
        <h1>Choose Your Plan</h1>
        <p>Scale your business with the right tools</p>
      </div>

      <div className="pricing-container">
        {/* Free Plan */}
        <div className="pricing-card">
          <div className="icon">🎁</div>
          <h3>Free</h3>
          <h2>
            AED 0 <span>forever</span>
          </h2>
          <ul>
            <li>Up to 10 products</li>
            <li>Basic analytics</li>
            <li>Email support</li>
            <li>Mobile app access</li>
            <li>Standard processing</li>
          </ul>
          <button className="btn black">Start Free</button>
        </div>

        {/* Grow Plan */}
        <div className="pricing-card highlight">
          <div className="icon">🚀</div>
          <h3>Grow</h3>
          <h2>
            AED 99 <span>per month</span>
          </h2>
          <ul>
            <li>Up to 100 products</li>
            <li>Advanced analytics</li>
            <li>AI content generation</li>
            <li>Priority support</li>
            <li>Marketing tools</li>
            <li>Customer insights</li>
          </ul>
          <button className="btn green">Current Plan</button>
        </div>

        {/* Pro Plan */}
        <div className="pricing-card">
          <div className="icon">💼</div>
          <h3>Pro</h3>
          <h2>
            AED 249 <span>per month</span>
          </h2>
          <ul>
            <li>Unlimited products</li>
            <li>Full AI suite</li>
            <li>Premium analytics</li>
            <li>Dedicated account manager</li>
            <li>Advanced marketing automation</li>
            <li>Custom integrations</li>
            <li>Early access to features</li>
          </ul>
          <button className="btn black">Upgrade Now</button>
        </div>

        {/* Youth Plan */}
        <div className="pricing-card special">
          <div className="special-tag">Special Program</div>
          <h3>Youth Innovators</h3>
          <h2>
            Free <span>for under 18</span>
          </h2>
          <ul>
            <li>All Pro features</li>
            <li>Mentorship program</li>
            <li>Educational resources</li>
            <li>Community access</li>
            <li>Special recognition badge</li>
          </ul>
          <button className="btn gold">Upgrade Now</button>
        </div>
      </div>

      <div className="benefits">
        <div>
          <h4>Cancel Anytime</h4>
          <p>No long-term commitments. Cancel or downgrade whenever you need.</p>
        </div>
        <div>
          <h4>Secure Payments</h4>
          <p>All transactions are encrypted and processed securely.</p>
        </div>
        <div>
          <h4>Instant Activation</h4>
          <p>Access new features immediately after upgrading.</p>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
